export default {"src":"/_next/static/media/bloomberg-logo.d9b6a56d.svg","height":30,"width":149,"blurWidth":0,"blurHeight":0};